import { YmStore } from './YmStore';
import { BaseVideoPayload, ProgressPayload } from './types';

export class AnalyticsStore {
  private _ym = new YmStore();

  play = (payload: BaseVideoPayload) => {
    this._ym.sendWithLog('video_play', payload);
  };

  pause = (payload: BaseVideoPayload) => {
    this._ym.sendWithLog('video_pause', payload);
  };

  ended = (payload: BaseVideoPayload) => {
    this._ym.sendWithLog('video_ended', payload);
  };

  progress = (payload: ProgressPayload) => {
    this._ym.sendWithLog('video_progress', payload);
  };
}
